import { useMutation } from "@tanstack/react-query";
import { UserRepositoryImpl } from "../../data/repository/user_repository_impl";
import { ModifyProfileInterface } from "../interface/modify_profile_interface";
import { AxiosError } from "axios";

export const useModifyProfile = () => {
    const repository = new UserRepositoryImpl();

    return useMutation<void, AxiosError, ModifyProfileInterface>({
        mutationFn: (newProfile: ModifyProfileInterface) => repository.modifyProfile(newProfile),
    });
}